import React, {Fragment} from 'react';

import BannedCashregisterForm from './StickerForm';
import Edit from '../../../../../Components/Edit/Edit';

class EditSticker extends React.Component {

    createSavedRedirect = () => {
        this.props.handleRequestClose();
    };

    handleGetFormInfo = () => {
        return this.props.getFormInfo('stickers');
    }

  render() {
    return (
        <Fragment>
            <Edit
                isViewPage={false}
                createSavedRedirect={this.createSavedRedirect.bind(this)}
                handleGetFormInfo={this.handleGetFormInfo.bind(this)}
                {...this.props}
            >
                <BannedCashregisterForm {...this.props} isViewPage={false} />
            </Edit>
        </Fragment>

    );
  }

}

export default EditSticker;